import { PortalProps } from './Portal.typed';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export function Portal(props: PortalProps) {
  const { children } = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  return mounted
    ? createPortal(
        children,
        document.querySelector('#myportal') ?? document.body,
      )
    : null;
}

export default Portal;
